import { render, staticRenderFns } from "./ChatList.vue?vue&type=template&id=b8a08c5c&"
import script from "./chatList.js?vue&type=script&lang=js&"
export * from "./chatList.js?vue&type=script&lang=js&"
import style0 from "./ChatList.vue?vue&type=style&index=0&id=b8a08c5c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports